import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { TRANSLATIONS } from '../../constants';
import { useTranslate } from '../../hooks/common';
import { getProductFileImage } from '../../services';
import { ApplicationState } from '../../store';
import Carousel from '../common/Carousel';
import DigitalNameplate from './DigitalNameplate';
import SupportEntries from './SupportEntries';

const ProductInfo = () => {
    const invalidProduct = useSelector((state: ApplicationState) => state.product.invalidProduct);
    const language = useSelector((state: ApplicationState) => state.translation.language);
    const product = useSelector((state: ApplicationState) => state.product.product);
    const supportEntries = product?.supportEntryCategories?.filter(x => x.language == language);

    return invalidProduct ? <Navigate to={'/'} replace /> : (
        <div className='product-info'>
            <Carousel slidesToShow={1}><img src={getProductFileImage(product?.keyImage)} /></Carousel>
            <DigitalNameplate attributes={product?.attributes ?? []} certImageIds={product?.certImages?.map(x => x.md5Value) ?? []} />
            <SupportEntries supportEntryCategories={supportEntries ?? []} />
        </div>
    );
};

export default ProductInfo;
